import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a2480fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "contains-loader"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_3 = {
  class: "breadcrumb has-succeeds-separator",
  "aria-label": "breadcrumbs"
}
const _hoisted_4 = { class: "is-active" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("All Campaign Notes")
const _hoisted_6 = { class: "control" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = { class: "control" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "control" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "section" }
const _hoisted_13 = { class: "content has-text-grey has-text-centered" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "No campaign notes to display", -1))
const _hoisted_15 = {
  class: "modal-card",
  style: {"width":"auto"}
}
const _hoisted_16 = { class: "card" }
const _hoisted_17 = { class: "card-content" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "Add Campaign Note", -1))
const _hoisted_19 = {
  id: "new",
  "data-vv-scope": "new"
}
const _hoisted_20 = { class: "control" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_31 = {
  class: "modal-card",
  style: {"width":"auto"}
}
const _hoisted_32 = { class: "card" }
const _hoisted_33 = { class: "card-content" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "Update Campaign Note", -1))
const _hoisted_35 = {
  id: "edit",
  "data-vv-scope": "edit"
}
const _hoisted_36 = { class: "control" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { UseAnnotations } from "./Hooks/UseAnnotations";
import moment from "moment";
import { includes } from "lodash";
import { useField } from "vee-validate";
import { storeToRefs } from "pinia";
import { UseDateStore } from "../../State/Stores/DateStore";
import { watchEffect } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    showAnnotationsTable: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { showAnnotationsTable: boolean }

const {
  loading,
  isCreateModalActive,
  checkers,
  data,
  editing,
  deleting,
  form,
  saving,
  isUpdateModalActive,
  openEdit,
  deleteAnnotation,
  saveAnnotation,
  saveExistingAnnotation,
} = UseAnnotations();

const { getDateFrom, getDateTo } = storeToRefs(UseDateStore());



const { value: annotation, errors, handleChange: handleAnnotationChange } = useField(
  "annotation"
);

const { value: edit, errors: editErrors } = useField("edit");

watchEffect(() => {
  form.new.annotation = annotation.value as string;
  form.edit.annotation = edit.value as string;
});

return (_ctx: any,_cache: any) => {
  const _component_o_loading = _resolveComponent("o-loading")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_o_field = _resolveComponent("o-field")!
  const _component_o_table_column = _resolveComponent("o-table-column")!
  const _component_o_icon = _resolveComponent("o-icon")!
  const _component_o_table = _resolveComponent("o-table")!
  const _component_o_datepicker = _resolveComponent("o-datepicker")!
  const _component_o_input = _resolveComponent("o-input")!
  const _component_o_modal = _resolveComponent("o-modal")!

  return (_openBlock(), _createBlock(_Transition, { name: "slide" }, {
    default: _withCtx(() => [
      (props.showAnnotationsTable)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _createVNode(_component_o_loading, {
              class: "is-loader-overlay",
              "full-page": false,
              active: _unref(loading),
              "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => (_isRef(loading) ? (loading).value = $event : null))
            }, null, 8, ["active"]),
            _createElementVNode("nav", _hoisted_3, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", _hoisted_4, [
                  _createVNode(_component_router_link, { to: "/performance" }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createVNode(_component_o_field, {
              grouped: "",
              "group-multiline": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_o_field, null, {
                  default: _withCtx(() => [
                    _createElementVNode("p", _hoisted_6, [
                      _createElementVNode("button", {
                        class: "button",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (isCreateModalActive.value = true))
                      }, " Add Campaign Note ")
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _hoisted_7,
            _createVNode(_component_o_table, {
              narrowed: "",
              hoverable: "",
              paginated: "",
              "pagination-simple": "",
              checkable: "",
              "per-page": 5,
              "checked-rows": _unref(checkers),
              "onUpdate:checked-rows": _cache[3] || (_cache[3] = ($event: any) => (_isRef(checkers) ? (checkers).value = $event : null)),
              data: _unref(data),
              "onUpdate:data": _cache[4] || (_cache[4] = ($event: any) => (_isRef(data) ? (data).value = $event : null))
            }, {
              empty: _withCtx(() => [
                _createElementVNode("section", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("p", null, [
                      _createVNode(_component_o_icon, {
                        icon: "emoticon-sad",
                        size: "is-large"
                      })
                    ]),
                    _hoisted_14,
                    _createElementVNode("a", {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (isCreateModalActive.value = true))
                    }, "Create one here")
                  ])
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_o_table_column, {
                  field: "text",
                  label: "Note"
                }, {
                  default: _withCtx((props) => [
                    _createTextVNode(_toDisplayString(props.row.text), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_o_table_column, {
                  field: "date",
                  label: "Date"
                }, {
                  default: _withCtx((props) => [
                    _createTextVNode(_toDisplayString(_unref(moment)(props.row.date).format("dddd, MMMM Do YYYY")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_o_table_column, {
                  field: "added_by",
                  label: "Added By"
                }, {
                  default: _withCtx((props) => [
                    _createTextVNode(_toDisplayString(props.row.added_by), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_o_table_column, {
                  field: "colour",
                  label: "Colour",
                  centered: ""
                }, {
                  default: _withCtx((props) => [
                    _createElementVNode("a", null, [
                      _createVNode(_component_o_icon, {
                        icon: 
                props.row.colour == '#775DD0'
                  ? 'checkbox-blank'
                  : 'checkbox-blank-outline'
              ,
                        style: {"color":"#775dd0"},
                        onClick: ($event: any) => (props.row.colour = '#775DD0')
                      }, null, 8, ["icon", "onClick"])
                    ]),
                    _createElementVNode("a", null, [
                      _createVNode(_component_o_icon, {
                        icon: 
                props.row.colour == '#FF4560'
                  ? 'checkbox-blank'
                  : 'checkbox-blank-outline'
              ,
                        style: {"color":"#ff4560"},
                        onClick: ($event: any) => (props.row.colour = '#FF4560')
                      }, null, 8, ["icon", "onClick"])
                    ]),
                    _createElementVNode("a", null, [
                      _createVNode(_component_o_icon, {
                        icon: 
                props.row.colour == '#FEB019'
                  ? 'checkbox-blank'
                  : 'checkbox-blank-outline'
              ,
                        style: {"color":"#feb019"},
                        onClick: ($event: any) => (props.row.colour = '#FEB019')
                      }, null, 8, ["icon", "onClick"])
                    ]),
                    _createElementVNode("a", null, [
                      _createVNode(_component_o_icon, {
                        icon: 
                props.row.colour == '#00E396'
                  ? 'checkbox-blank'
                  : 'checkbox-blank-outline'
              ,
                        style: {"color":"#00e396"},
                        onClick: ($event: any) => (props.row.colour = '#00E396')
                      }, null, 8, ["icon", "onClick"])
                    ]),
                    _createElementVNode("a", null, [
                      _createVNode(_component_o_icon, {
                        icon: 
                props.row.colour == '#2799FF'
                  ? 'checkbox-blank'
                  : 'checkbox-blank-outline'
              ,
                        style: {"color":"#2799ff"},
                        onClick: ($event: any) => (props.row.colour = '#2799FF')
                      }, null, 8, ["icon", "onClick"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_o_table_column, {
                  label: "Actions",
                  numeric: ""
                }, {
                  default: _withCtx((props) => [
                    _createVNode(_component_o_field, { class: "is-pulled-right" }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", _hoisted_8, [
                          _createElementVNode("button", {
                            class: _normalizeClass([
                  'button',
                  'is-primary',
                  'is-small',
                  'is-outlined',
                  { 'is-loading': _unref(includes)(_unref(editing), props.row.id) },
                ]),
                            onClick: _withModifiers(($event: any) => (_unref(openEdit)(props.row)), ["prevent"])
                          }, " Edit ", 10, _hoisted_9)
                        ]),
                        _createElementVNode("p", _hoisted_10, [
                          _createElementVNode("button", {
                            class: _normalizeClass([
                  'button',
                  'is-danger',
                  'is-small',
                  'is-outlined',
                  { 'is-loading': _unref(includes)(_unref(deleting), props.row.id) },
                ]),
                            onClick: _withModifiers(($event: any) => (_unref(deleteAnnotation)(props.row.id)), ["prevent"])
                          }, " Delete ", 10, _hoisted_11)
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["checked-rows", "data"]),
            _createVNode(_component_o_modal, {
              active: _unref(isCreateModalActive),
              "onUpdate:active": _cache[8] || (_cache[8] = ($event: any) => (_isRef(isCreateModalActive) ? (isCreateModalActive).value = $event : null))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _createElementVNode("section", null, [
                        _createElementVNode("form", _hoisted_19, [
                          _createVNode(_component_o_field, {
                            label: "Date",
                            type: { 'is-danger': _unref(errors).length },
                            message: _unref(errors)[0]
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("p", _hoisted_20, [
                                _createVNode(_component_o_datepicker, {
                                  placeholder: "Click to select...",
                                  name: "formDate",
                                  "data-vv-as": "annotation date",
                                  modelValue: _unref(form).new.date,
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).new.date) = $event)),
                                  "min-date": _unref(moment)(_unref(getDateFrom)).toDate(),
                                  "max-date": _unref(moment)(_unref(getDateTo)).toDate()
                                }, null, 8, ["modelValue", "min-date", "max-date"])
                              ])
                            ]),
                            _: 1
                          }, 8, ["type", "message"]),
                          _createVNode(_component_o_field, {
                            label: "Annotation",
                            type: {
                      'is-danger': _unref(errors).length,
                    },
                            message: _unref(errors)[0]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_o_input, {
                                type: "text",
                                modelValue: _unref(annotation),
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(annotation) ? (annotation).value = $event : null)),
                                name: "form.new.annotation",
                                "data-vv-as": "note text",
                                onChange: _unref(handleAnnotationChange)
                              }, null, 8, ["modelValue", "onChange"])
                            ]),
                            _: 1
                          }, 8, ["type", "message"]),
                          _createVNode(_component_o_field, { label: "" }, {
                            default: _withCtx(() => [
                              _createElementVNode("button", {
                                class: _normalizeClass(['button', 'is-success', { 'is-loading': _unref(saving) }]),
                                onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_unref(saveAnnotation) && _unref(saveAnnotation)(...args)), ["prevent"]))
                              }, " Save Campaign Note ", 2)
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _hoisted_21,
                      _hoisted_22,
                      _hoisted_23,
                      _hoisted_24,
                      _hoisted_25,
                      _hoisted_26,
                      _hoisted_27,
                      _hoisted_28,
                      _hoisted_29,
                      _hoisted_30
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["active"]),
            _createVNode(_component_o_modal, { active: _unref(isUpdateModalActive) }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _hoisted_34,
                      _createElementVNode("section", null, [
                        _createElementVNode("form", _hoisted_35, [
                          _createVNode(_component_o_field, {
                            label: "Date",
                            type: { 'is-danger': _unref(editErrors).length },
                            message: _unref(editErrors)[0]
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("p", _hoisted_36, [
                                _createVNode(_component_o_datepicker, {
                                  placeholder: "Click to select...",
                                  name: "formDate",
                                  "data-vv-as": "annotation date",
                                  modelValue: _unref(form).edit.date,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(form).edit.date) = $event)),
                                  "min-date": _unref(moment)(_unref(getDateFrom)).toDate(),
                                  "max-date": _unref(moment)(_unref(getDateTo)).toDate()
                                }, null, 8, ["modelValue", "min-date", "max-date"])
                              ])
                            ]),
                            _: 1
                          }, 8, ["type", "message"]),
                          _createVNode(_component_o_field, {
                            label: "Annotation",
                            type: { 'is-danger': _unref(editErrors).length },
                            message: _unref(editErrors)[0]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_o_input, {
                                type: "text",
                                modelValue: _unref(form).edit.annotation,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(form).edit.annotation) = $event)),
                                name: "form.edit.annotation",
                                "data-vv-as": "note text"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["type", "message"]),
                          _createVNode(_component_o_field, { label: "" }, {
                            default: _withCtx(() => [
                              _createElementVNode("button", {
                                class: _normalizeClass(['button', 'is-success', { 'is-loading': _unref(saving) }]),
                                onClick: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_unref(saveExistingAnnotation) && _unref(saveExistingAnnotation)(...args)), ["prevent"]))
                              }, " Save Campaign Note ", 2)
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _hoisted_37,
                      _hoisted_38,
                      _hoisted_39,
                      _hoisted_40,
                      _hoisted_41,
                      _hoisted_42,
                      _hoisted_43,
                      _hoisted_44,
                      _hoisted_45,
                      _hoisted_46
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["active"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})